import { connect } from 'react-redux';

import SLICK from 'config/slick.singleton';
import { selectOldFlagsFeatures } from 'selectors/oldFlags.selectors';
import asObject from 'utils/objects/asObject.util';

// NOTE: this is a drop-in replacement for ToggleFeature of the library flopflip/react-redux
// SEE: https://getslick.atlassian.net/browse/GS-10404
//
// DEPRECATED: use SalonFlag component and the salon flags field instead
// SEE: src/components/core/SalonFlag.component.jsx

const ToggleFeature = ({ children, flag: name, flags }) => {
  // NOTE: this is a temporary index for logging which flag had been used and which has been set
  SLICK.makeshiftStore.keys = SLICK.makeshiftStore.keys || {};
  SLICK.makeshiftStore.keys[name] = true;

  // this is the actual useful part: render children or not, based on the flag value
  const value = asObject(flags)[name];
  return value ? children : null;
};

const mapStateToProps = (state) => ({ flags: selectOldFlagsFeatures(state) });

const ToggleFeatureHoc = connect(mapStateToProps)(ToggleFeature);

export default ToggleFeatureHoc;
